import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from 'react';
import menuItem from 'menu-items';
// material-ui
import { useTheme, styled } from '@mui/material/styles';
import {
    Avatar,
    Box,
    ButtonBase,
    Card,
    ClickAwayListener,
    Fade,
    Grid,
    InputAdornment,
    List,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    ListSubheader,
    OutlinedInput,
    Paper,
    Popper,
    Typography,
    useMediaQuery
} from '@mui/material';

// third-party
import PopupState, { bindPopper, bindToggle } from 'material-ui-popup-state';

// project imports
import Transitions from 'ui-component/extended/Transitions';
// assets
import { IconAdjustmentsHorizontal, IconSearch, IconX } from '@tabler/icons';
import { shouldForwardProp } from '@mui/system';
import MainCard from 'ui-component/cards/MainCard';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { useNavigate } from 'react-router';
// styles
const PopperStyle = styled(Popper, { shouldForwardProp })(({ theme }) => ({
    zIndex: 1100,
    width: '99%',
    top: '-55px !important',
    padding: '0 12px',
    [theme.breakpoints.down('sm')]: {
        padding: '0 10px'
    }
}));

const OutlineInputStyle = styled(OutlinedInput, { shouldForwardProp })(({ theme }) => ({
    width: 434,
    marginLeft: 16,
    paddingLeft: 16,
    paddingRight: 16,
    '& input': {
        background: 'transparent !important',
        paddingLeft: '4px !important'
    },
    [theme.breakpoints.down('lg')]: {
        width: 250
    },
    [theme.breakpoints.down('md')]: {
        width: '100%',
        marginLeft: 4,
        background: '#fff'
    }
}));

const HeaderAvatarStyle = styled(Avatar, { shouldForwardProp })(({ theme }) => ({
    ...theme.typography.commonAvatar,
    ...theme.typography.mediumAvatar,
    background: theme.palette.secondary.light,
    color: theme.palette.secondary.dark,
    '&:hover': {
        background: theme.palette.secondary.dark,
        color: theme.palette.secondary.light
    }
}));

// ==============================|| SEARCH INPUT - MOBILE||============================== //

const MobileSearch = ({ value, setValue, popupState, handleToggle, open }) => {
    const theme = useTheme();

    return (
        <OutlineInputStyle
            id="input-search-header"
            value={value}
            onClick={handleToggle}
            aria-controls={open ? 'menu-list-grow' : undefined}
            onChange={(e) => setValue(e.target.value)}
            placeholder="Search"
            startAdornment={
                <InputAdornment position="start">
                    <IconSearch stroke={1.5} size="1rem" color={theme.palette.grey[500]} />
                </InputAdornment>
            }
            endAdornment={
                <InputAdornment position="end">
                    {/* <ButtonBase sx={{ borderRadius: '12px' }}>
                        <HeaderAvatarStyle variant="rounded">
                            <IconAdjustmentsHorizontal stroke={1.5} size="1.3rem" />
                        </HeaderAvatarStyle>
                    </ButtonBase> */}
                    <Box sx={{ ml: 2 }}>
                        <ButtonBase sx={{ borderRadius: '12px' }}>
                            <Avatar
                                variant="rounded"
                                sx={{
                                    ...theme.typography.commonAvatar,
                                    ...theme.typography.mediumAvatar,
                                    background: theme.palette.orange.light,
                                    color: theme.palette.orange.dark,
                                    '&:hover': {
                                        background: theme.palette.orange.dark,
                                        color: theme.palette.orange.light
                                    }
                                }}
                                {...bindToggle(popupState)}
                            >
                                <IconX stroke={1.5} size="1.3rem" />
                            </Avatar>
                        </ButtonBase>
                    </Box>
                </InputAdornment>
            }
            inputProps={{ 'aria-label': 'weight' }}
        />
    );
};

MobileSearch.propTypes = {
    value: PropTypes.string,
    setValue: PropTypes.func,
    popupState: PopupState
};

// ==============================|| SEARCH INPUT ||============================== //

const SearchSection = () => {
    const theme = useTheme();
    const [value, setValue] = useState('');
    const [anchorEl, setAnchorEl] = useState(null);
    const navigate = useNavigate();
    const matchesXs = useMediaQuery(theme.breakpoints.down('md'));
    const anchorRef = useRef(null);
    const [MenuFind, setMenuFind] = useState({});
    const [open, setOpen] = useState(false);
    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }
        setOpen(false);
    };

    useEffect(() => {
        // console.log(menuItem);
        const Data = [];

        menuItem.items.map((item) => {
            const menus = item.children
                ?.map((menu) => {
                    switch (menu.type) {
                        case 'collapse':
                            const dataCollapse = menu.children
                                ?.map((itemCollapse) => {
                                    // const dataItem = itemCollapse.filter((item) => item.title.toLowerCase().includes(value.toLowerCase()));
                                    if (itemCollapse.title.toLowerCase().includes(value.toLowerCase())) {
                                        return itemCollapse;
                                    } else {
                                        return null;
                                    }
                                })
                                .filter(Boolean);
                            return { ...menu, children: dataCollapse };
                        case 'item':
                            if (menu.title.toLowerCase().includes(value.toLowerCase())) {
                                return menu;
                            }
                        default:
                            return null;
                    }
                })
                .filter(Boolean);
            Data.push({ ...item, children: menus });
        });
        // console.log(Data);
        setMenuFind({ ...menuItem, items: value.toLowerCase() !== '' ? Data : menuItem.items });
    }, [value]);
    function Menulist(menu) {
        return menu?.items.map((item) => {
            // return <Typography sx={{ p: 2, fontWeight: 600 }}>{item.title}</Typography>;

            return (
                <List
                    key={item.id}
                    sx={{ width: '100%', bgcolor: 'background.paper' }}
                    component="nav"
                    aria-labelledby="nested-list-subheader"
                    subheader={
                        <ListSubheader component="div" id="nested-list-subheader">
                            {item.title}
                        </ListSubheader>
                    }
                >
                    {item.children?.map((menu) => {
                        const Icon = menu?.icon;
                        const itemIcon = menu?.icon ? <Icon stroke={1.5} size="1.3rem" /> : <FiberManualRecordIcon />;
                        switch (menu.type) {
                            case 'collapse':
                                return menu.children?.map((itemCollapse) => {
                                    const Icon = itemCollapse?.icon;
                                    const itemIcon = itemCollapse?.icon ? <Icon stroke={1.5} size="1.3rem" /> : <FiberManualRecordIcon />;
                                    return (
                                        <ListItemButton
                                            key={itemCollapse.id}
                                            onClick={() => {
                                                navigate(itemCollapse.url);
                                            }}
                                        >
                                            <ListItemIcon
                                                sx={{
                                                    my: 'auto',
                                                    minWidth: !itemCollapse?.icon ? 18 : 36
                                                }}
                                            >
                                                {itemIcon}
                                            </ListItemIcon>
                                            <ListItemText primary={itemCollapse.title} />
                                        </ListItemButton>
                                    );
                                });
                            case 'item':
                                return (
                                    <ListItemButton
                                        key={menu.id}
                                        onClick={() => {
                                            navigate(menu.url);
                                        }}
                                    >
                                        <ListItemIcon
                                            sx={{
                                                my: 'auto',
                                                minWidth: !menu?.icon ? 18 : 36
                                            }}
                                        >
                                            {itemIcon}
                                        </ListItemIcon>
                                        <ListItemText primary={menu.title} />
                                    </ListItemButton>
                                );
                            default:
                                return (
                                    <Typography key={menu.id} variant="h6" color="error" align="center">
                                        Menu Items Error
                                    </Typography>
                                );
                        }
                    })}
                </List>
            );
        });
    }
    return (
        <>
            <Box sx={{ display: { xs: 'block', md: 'none' } }} ref={anchorRef} aria-controls={open ? 'menu-list-grow' : undefined}>
                <PopupState variant="popper" popupId="demo-popup-popper">
                    {(popupState) => (
                        <>
                            <Box sx={{ ml: 2 }}>
                                <ButtonBase sx={{ borderRadius: '12px' }}>
                                    <HeaderAvatarStyle variant="rounded" {...bindToggle(popupState)}>
                                        <IconSearch stroke={1.5} size="1.2rem" />
                                    </HeaderAvatarStyle>
                                </ButtonBase>
                            </Box>
                            <PopperStyle {...bindPopper(popupState)} transition>
                                {({ TransitionProps }) => (
                                    <>
                                        <Transitions type="zoom" {...TransitionProps} sx={{ transformOrigin: 'center left' }}>
                                            <Card
                                                sx={{
                                                    background: '#fff',
                                                    [theme.breakpoints.down('sm')]: {
                                                        border: 0,
                                                        boxShadow: 'none'
                                                    }
                                                }}
                                            >
                                                <Box sx={{ p: 2 }}>
                                                    <Grid container alignItems="center" justifyContent="space-between">
                                                        <Grid item xs>
                                                            <MobileSearch
                                                                value={value}
                                                                setValue={setValue}
                                                                popupState={popupState}
                                                                handleToggle={handleToggle}
                                                                open={open}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                </Box>
                                            </Card>
                                        </Transitions>
                                        <Transitions type="zoom" {...TransitionProps} sx={{ transformOrigin: 'center left' }}>
                                            <MainCard border={false} elevation={16} content={false} boxShadow shadow={theme.shadows[16]}>
                                                {Menulist(MenuFind)}
                                            </MainCard>
                                        </Transitions>
                                    </>
                                )}
                            </PopperStyle>
                        </>
                    )}
                </PopupState>
            </Box>
            <Box sx={{ display: { xs: 'none', md: 'block' } }}>
                <OutlineInputStyle
                    value={value}
                    ref={anchorRef}
                    aria-controls={open ? 'menu-list-grow' : undefined}
                    onClick={handleToggle}
                    onChange={(e) => {
                        setValue(e.target.value);
                        setOpen(true);
                    }}
                    placeholder="Search"
                    startAdornment={
                        <InputAdornment position="start">
                            <IconSearch stroke={1.5} size="1rem" color={theme.palette.grey[500]} />
                        </InputAdornment>
                    }
                    // endAdornment={
                    //     <InputAdornment position="end">
                    //         <ButtonBase sx={{ borderRadius: '12px' }}>
                    //             <HeaderAvatarStyle variant="rounded">
                    //                 <IconAdjustmentsHorizontal stroke={1.5} size="1.3rem" />
                    //             </HeaderAvatarStyle>
                    //         </ButtonBase>
                    //     </InputAdornment>
                    // }
                    inputProps={{ 'aria-label': 'weight' }}
                />
                <Popper
                    placement={matchesXs ? 'bottom' : 'bottom-end'}
                    open={open}
                    anchorEl={anchorRef.current}
                    role={undefined}
                    transition
                    disablePortal
                    popperOptions={{
                        modifiers: [
                            {
                                name: 'offset',
                                options: {
                                    offset: [matchesXs ? 5 : 0, 20]
                                }
                            }
                        ]
                    }}
                    style={{
                        width: 434,

                        [theme.breakpoints.down('lg')]: {
                            width: 250
                        },
                        [theme.breakpoints.down('md')]: {
                            width: '100%',
                            marginLeft: 4,
                            background: '#fff'
                        }
                    }}
                >
                    {({ TransitionProps }) => (
                        <>
                            <Transitions type="zoom" {...TransitionProps} sx={{ transformOrigin: 'left top' }}>
                                <Paper>
                                    <ClickAwayListener onClickAway={handleClose}>
                                        <MainCard
                                            border={false}
                                            elevation={16}
                                            content={false}
                                            boxShadow
                                            shadow={theme.shadows[16]}
                                            sx={{ maxHeight: 500, overflow: 'scroll' }}
                                        >
                                            {Menulist(MenuFind)}
                                        </MainCard>
                                    </ClickAwayListener>
                                </Paper>
                            </Transitions>
                        </>
                    )}
                </Popper>
            </Box>
        </>
    );
};

export default SearchSection;
